import { Injectable, OnDestroy, LOCALE_ID, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

/**
 * Manages the load of translations from a ressource path.
 *
 */
@Injectable()
export class LanguageService implements OnDestroy {
  languageSubscription: Subscription;
  private currentLanguage: string;
  defaultLocale = 'en_gb';

  public readonly supportedLocales = {
    en_US: {
      locale: 'en_US',
      title: 'English',
      languageCode: 'en-US',
      languageCLP: 'en_us'
    },
    it_IT: {
      locale: 'it_IT',
      title: 'Italiano',
      languageCode: 'it',
      languageCLP: 'it_it'
    },
    de_DE: {
      locale: 'de_DE',
      title: 'Deutsch',
      languageCode: 'de',
      languageCLP: 'de_de'
    },
    uk_UA: {
      locale: 'uk_UA',
      title: 'Ukrainian',
      languageCode: 'uk',
      languageCLP: 'en_gb'
    },
    tr_TR: {
      locale: 'tr_TR',
      title: 'Türk',
      languageCode: 'tr',
      languageCLP: 'en_gb'
    },
    pt_BR: {
      locale: 'pt_BR',
      title: 'Português do Brasil',
      languageCode: 'pt',
      languageCLP: 'pt_pt'
    },
    ru_RU: {
      locale: 'ru_RU',
      title: 'Русский',
      languageCode: 'ru',
      languageCLP: 'ru_ru'
    },
    fr_FR: {
      locale: 'fr_FR',
      title: 'Français',
      languageCode: 'fr',
      languageCLP: 'fr_fr'
    },
    ja_JP: {
      locale: 'ja_JP',
      title: '日本語',
      languageCode: 'ja',
      languageCLP: 'ja_jp'
    },
    es_ES: {
      locale: 'es_ES',
      title: 'Español',
      languageCode: 'es',
      languageCLP: 'es_es'
    },
    zh_Hant_TW: {
      locale: 'zh_Hant_TW',
      title: '繁體中文',
      languageCode: 'zh-Hant',
      languageCLP: 'zh_tw'
    },
    id_ID: {
      locale: 'id_ID',
      title: 'Indonesian',
      languageCode: 'id',
      languageCLP: 'id_id'
    },
    he_IL: {
      locale: 'he_IL',
      title: 'עִברִית',
      languageCode: 'he',
      languageCLP: 'he_he'
    },
    zh_Hans_CN: {
      locale: 'zh_Hans_CN',
      title: '简体中文',
      languageCode: 'zh',
      languageCLP: 'zh_cn'
    },
    [this.defaultLocale]: {
      locale: 'en_GB',
      title: 'English',
      languageCode: 'en-GB',
      languageCLP: 'en_gb'
    }
  };

  constructor(@Inject(LOCALE_ID) private readonly locale: string, private readonly http: HttpClient) {}

  // setting up the language picked up from drop down
  setLanguage(lang: string, force?: boolean, _translate?: any) {
    if (lang === this.currentLanguage && force !== true) {
      return;
    }
    this.currentLanguage = lang;
  }
  // set clp language code
  getLanguageCLPCode(selectedLocale : string): string {
    const locale = selectedLocale ? selectedLocale : this.defaultLocale;
    const supportedLocale = this.supportedLocales[locale];
    return supportedLocale.languageCLP;
  }

  ngOnDestroy() {
    if (this.languageSubscription && !this.languageSubscription.closed) {
      this.languageSubscription.unsubscribe();
    }
  }
}
